export default __webpack_public_path__ + "media/images/Bright-News-Black-Text-Transparent-6b236326778ec3240bc4566e1c3f9ad0.png";